import { createApi } from '@reduxjs/toolkit/query/react';

import { settings } from '@/_config';

import baseQueryWithReAuth from '../helper/base-query-with-auth';

// Define a service using a base URL and expected endpoints
const checkoutApis = createApi({
  reducerPath: 'checkoutApis',

  tagTypes: ['UNIFIED_RACE_CONDITION'],
  baseQuery: baseQueryWithReAuth({
    baseUrl: settings.baseURL[3],
    appName: 'CHECKOUT',
    authRequired: false,
    // baseUrl: 'https://f8e76a08-c206-44a6-bd3c-b447c1f84cb9.mock.pstmn.io/api/v1/',
  }),
  endpoints: () => ({}),
});

export default checkoutApis;
